export default __webpack_public_path__ + "static/media/DSC09955.b505c0d4.jpg";